import CRUDService from "../../services/base/CRUDService";

export default class PolygonService extends CRUDService {

  static ALL_URL = "polygon/v1/polygons/";

  getBaseURL() {
    return PolygonService.ALL_URL;
  }

}



// WEBPACK FOOTER //
// ./src/map/polygon/PolygonService.js